var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.16 254.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-21{mix-blend-mode:lighten;}.cls-1{opacity:0.5;fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45);}.cls-2{fill:none;}.cls-3{isolation:isolate;}.cls-4{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_24);}.cls-5{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2);}.cls-10,.cls-24,.cls-6{fill:#24126a;}.cls-16,.cls-6{opacity:0.3;}.cls-7{fill:#fff;}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-2);}.cls-9{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_24-2);}.cls-11,.cls-15{opacity:0.51;}.cls-12,.cls-15{fill:#453c9e;}.cls-13{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_24-3);}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-3);}.cls-17{clip-path:url(#clip-path);}.cls-18{fill:#42e8e0;}.cls-19{fill:#2fd3c7;}.cls-20{fill:#18b2a3;opacity:0.7;}.cls-21{opacity:0.8;fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_56);}.cls-22{opacity:0.15;}.cls-23{clip-path:url(#clip-path-2);}.cls-24{opacity:0.4;}.cls-25{fill:#9ffff8;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45",
    cx: 402.58,
    cy: 229.49,
    r: 160.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42e8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#37b6bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2c87a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#235f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#1c3f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#162561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#121355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#10084e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f054c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_24",
    x1: 503.62,
    y1: 261.86,
    x2: 288.07,
    y2: 261.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5761d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5c66d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6a73df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8289e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a3a7f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbeff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2",
    x1: 273.91,
    y1: 256.84,
    x2: 489.45,
    y2: 256.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 709.14, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0bff6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c5c4f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d3d2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-2",
    x1: 181.08,
    y1: 162.29,
    x2: 333.62,
    y2: 162.29,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_24-2",
    x1: 181.08,
    y1: 201.41,
    x2: 207.28,
    y2: 201.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 709.14, 0)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_24-3",
    x1: 201.52,
    y1: 244.09,
    x2: 416.95,
    y2: 244.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 709.14, 0)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-3",
    x1: 273.91,
    y1: 238.2,
    x2: 489.45,
    y2: 238.2,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-280.9 -70.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.3,221.5,424,297a5.34,5.34,0,0,0,4.83.2l78-45c1.24-.71,1.08-2-.35-2.79l-130.7-75.46a5.34,5.34,0,0,0-4.83-.2l-78,45C291.71,219.43,291.87,220.67,293.3,221.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_56",
    x1: 291.81,
    y1: 235.42,
    x2: 507.97,
    y2: 235.42,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-280.9 -70.43)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "524.42 151.75 391.75 75.19 375.09 174.29 507.66 250.8 524.42 151.75"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507.66,272.33l-7.19-1-124.69-72a5.34,5.34,0,0,0-4.83-.2L296.69,242l-4.57-.66v6.07h0A2,2,0,0,0,293.3,249L424,324.41a5.34,5.34,0,0,0,4.83.2l78-45a1.4,1.4,0,0,0,.82-1.23h0Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.3,242.92,424,318.38a5.34,5.34,0,0,0,4.83.2l78-45c1.24-.71,1.08-2-.35-2.79L375.78,195.3a5.37,5.37,0,0,0-4.83-.2l-78,45C291.71,240.85,291.87,242.09,293.3,242.92Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.62,244.4l116.82,67.45a4.82,4.82,0,0,0,4.32.17l69.71-40.24c1.11-.64,1-1.76-.31-2.5L378.34,201.84a4.79,4.79,0,0,0-4.32-.18L304.31,241.9C303.2,242.54,303.34,243.66,304.62,244.4Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M506.83,272.89l-78,45a5.34,5.34,0,0,1-4.83-.2L293.3,242.26a2.22,2.22,0,0,1-1.12-1.25c-.2.64.18,1.37,1.12,1.91L424,318.38a5.34,5.34,0,0,0,4.83.2l78-45a1.33,1.33,0,0,0,.77-1.54A1.56,1.56,0,0,1,506.83,272.89Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M375.54,171.77l16.53-98-1.33-.56,2-1.14h0a1.43,1.43,0,0,1,1.54.11l132,76.23a3.73,3.73,0,0,1,1.72,3.36l-16.66,98.8a1.23,1.23,0,0,1-.69,1h0l-1.95,1.13-.34-1.82.11,0L377.26,175.13A3.73,3.73,0,0,1,375.54,171.77Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M525.58,151.08l2.17-1a3.07,3.07,0,0,1,.28,1.64l-16.66,98.8a1.23,1.23,0,0,1-.69,1h0l-1.95,1.13-.34-1.82.11,0-6.64-3.83Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M375.19,176.32l132,76.23c1,.59,1.89.25,2.07-.8L526,152.94a3.71,3.71,0,0,0-1.71-3.35l-132-76.23c-1-.59-1.89-.25-2.07.8L373.47,173A3.73,3.73,0,0,0,375.19,176.32Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "110.86 4.77 243.52 81.33 226.77 180.38 94.19 103.87 110.86 4.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.19,223.09l7.2,3.77,72.26-41.72a5.24,5.24,0,0,1,4.71.19l124.63,72c1.19-.67,6.63-3.29,6.63-3.29L505,258.29h0a1.55,1.55,0,0,1-.74.82L428.13,303a5.23,5.23,0,0,1-4.72-.2L295.89,229.21a2.23,2.23,0,0,1-1.07-1.13h0Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M293.3,224.28,424,299.74a5.4,5.4,0,0,0,4.83.2l78-45c1.24-.72,1.08-2-.35-2.79l-130.7-75.46a5.34,5.34,0,0,0-4.83-.2l-78,45C291.71,222.2,291.87,223.45,293.3,224.28Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M293.3,224.28,424,299.74a5.4,5.4,0,0,0,4.83.2l78-45c1.24-.72,1.08-2-.35-2.79l-130.7-75.46a5.34,5.34,0,0,0-4.83-.2l-78,45C291.71,222.2,291.87,223.45,293.3,224.28Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M293.3,224.28,424,299.74a5.4,5.4,0,0,0,4.83.2l78-45c1.24-.72,1.08-2-.35-2.79l-130.7-75.46a5.34,5.34,0,0,0-4.83-.2l-78,45C291.71,222.2,291.87,223.45,293.3,224.28Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.3,221.5,424,297a5.34,5.34,0,0,0,4.83.2l78-45c1.24-.71,1.08-2-.35-2.79l-130.7-75.46a5.34,5.34,0,0,0-4.83-.2l-78,45C291.71,219.43,291.87,220.67,293.3,221.5Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 109.37 137.01 122.96 144.86 136.55 137.01 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 144.86 109.37 137.01 109.37 121.32 122.96 129.16 122.96 144.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 137.01 122.96 144.86 122.96 129.16 136.55 121.32 136.55 137.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 122.96 113.47 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 129.16 109.96 121.66 109.37 122 122.96 129.84 136.55 122 135.96 121.66 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 127.02 147.09 140.62 154.93 154.21 147.09 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 154.93 127.02 147.09 127.02 131.39 140.62 139.24 140.62 154.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 147.09 140.62 154.93 140.62 139.24 154.21 131.39 154.21 147.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 140.62 123.54 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 139.24 127.61 131.73 127.02 132.07 140.62 139.92 154.21 132.07 153.62 131.73 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 149.31 144.68 141.47 144.68 157.16 158.27 165.01 171.87 157.16 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 165.01 144.68 157.16 144.68 141.47 158.27 149.31 158.27 165.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 157.16 158.27 165.01 158.27 149.31 171.87 141.47 171.87 157.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 149.31 144.68 141.47 158.27 133.62 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 149.31 145.27 141.81 144.68 142.15 158.27 149.99 171.87 142.15 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 91.71 147.77 105.3 155.61 118.9 147.77 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 155.61 91.71 147.77 91.71 132.07 105.3 139.92 105.3 155.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 147.77 105.3 155.61 105.3 139.92 118.9 132.07 118.9 147.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 105.3 124.22 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 139.92 92.3 132.41 91.71 132.75 105.3 140.6 118.9 132.75 118.31 132.41 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 109.37 157.84 122.96 165.69 136.55 157.84 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 165.69 109.37 157.84 109.37 142.15 122.96 149.99 122.96 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 157.84 122.96 165.69 122.96 149.99 136.55 142.15 136.55 157.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 122.96 134.3 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 149.99 109.96 142.49 109.37 142.83 122.96 150.67 136.55 142.83 135.96 142.49 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 160.07 127.02 152.22 127.02 167.91 140.62 175.76 154.21 167.91 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 175.76 127.02 167.91 127.02 152.22 140.62 160.07 140.62 175.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 167.91 140.62 175.76 140.62 160.07 154.21 152.22 154.21 167.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 160.07 127.02 152.22 140.62 144.37 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 160.07 127.61 152.56 127.02 152.9 140.62 160.75 154.21 152.9 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 150.67 74.06 142.83 74.06 158.52 87.65 166.37 101.24 158.52 101.24 142.83 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 166.37 74.06 158.52 74.06 142.83 87.65 150.67 87.65 166.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 158.52 87.65 166.37 87.65 150.67 101.24 142.83 101.24 158.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 150.67 74.06 142.83 87.65 134.98 101.24 142.83 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 150.67 74.06 142.83 74.06 143.51 87.65 151.35 101.24 143.51 100.65 143.17 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 160.75 91.71 152.9 91.71 168.6 105.3 176.44 118.9 168.6 118.9 152.9 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 176.44 91.71 168.6 91.71 152.9 105.3 160.75 105.3 176.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 168.6 105.3 176.44 105.3 160.75 118.9 152.9 118.9 168.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 160.75 91.71 152.9 105.3 145.05 118.9 152.9 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 160.75 91.71 152.9 91.71 153.58 105.3 161.43 118.9 153.58 118.31 153.24 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 170.82 109.37 162.97 109.37 178.67 122.96 186.52 136.55 178.67 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 186.52 109.37 178.67 109.37 162.97 122.96 170.82 122.96 186.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 178.67 122.96 186.52 122.96 170.82 136.55 162.97 136.55 178.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 170.82 109.37 162.97 122.96 155.13 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 170.82 109.37 162.97 109.37 163.66 122.96 171.5 136.55 163.66 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 108.33 109.37 100.49 109.37 116.18 122.96 124.03 136.55 116.18 136.55 100.49 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 124.03 109.37 116.18 109.37 100.49 122.96 108.33 122.96 124.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 116.18 122.96 124.03 122.96 108.33 136.55 100.49 136.55 116.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 108.33 109.37 100.49 122.96 92.64 136.55 100.49 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 108.33 109.96 100.83 109.37 101.17 122.96 109.02 136.55 101.17 135.96 100.83 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "122.96 168.27 113.69 162.91 122.96 157.56 132.23 162.91 122.96 168.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "105.3 158.19 96.03 152.84 105.3 147.49 114.58 152.84 105.3 158.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.62 157.51 131.34 152.16 140.62 146.81 149.89 152.16 140.62 157.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 146.88 149.03 141.53 158.31 136.17 167.58 141.53 158.31 146.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 148.12 78.38 142.76 87.65 137.41 96.92 142.76 87.65 148.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 118.41 127.02 110.56 127.02 126.26 140.62 134.1 154.21 126.26 154.21 110.56 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 134.1 127.02 126.26 127.02 110.56 140.62 118.41 140.62 134.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 126.26 140.62 134.1 140.62 118.41 154.21 110.56 154.21 126.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 118.41 127.02 110.56 140.62 102.71 154.21 110.56 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 118.41 127.61 110.9 127.02 111.24 140.62 119.09 154.21 111.24 153.62 110.9 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 128.48 144.68 120.64 144.68 136.33 158.27 144.18 171.87 136.33 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 144.18 144.68 136.33 144.68 120.64 158.27 128.48 158.27 144.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 136.33 158.27 144.18 158.27 128.48 171.87 120.64 171.87 136.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 128.48 144.68 120.64 158.27 112.79 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 128.48 145.27 120.98 144.68 121.32 158.27 129.16 171.87 121.32 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 119.09 91.71 111.24 91.71 126.94 105.3 134.78 118.9 126.94 118.9 111.24 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 134.78 91.71 126.94 91.71 111.24 105.3 119.09 105.3 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 126.94 105.3 134.78 105.3 119.09 118.9 111.24 118.9 126.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 119.09 91.71 111.24 105.3 103.39 118.9 111.24 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 119.09 92.3 111.58 91.71 111.92 105.3 119.77 118.9 111.92 118.31 111.58 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 109.37 137.01 122.96 144.86 136.55 137.01 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 144.86 109.37 137.01 109.37 121.32 122.96 129.16 122.96 144.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 137.01 122.96 144.86 122.96 129.16 136.55 121.32 136.55 137.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 122.96 113.47 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 129.16 109.96 121.66 109.37 122 122.96 129.84 136.55 122 135.96 121.66 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 127.02 147.09 140.62 154.93 154.21 147.09 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 154.93 127.02 147.09 127.02 131.39 140.62 139.24 140.62 154.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 147.09 140.62 154.93 140.62 139.24 154.21 131.39 154.21 147.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 140.62 123.54 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 139.24 127.61 131.73 127.02 132.07 140.62 139.92 154.21 132.07 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 129.84 74.06 122 74.06 137.69 87.65 145.54 101.24 137.69 101.24 122 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 145.54 74.06 137.69 74.06 122 87.65 129.84 87.65 145.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 137.69 87.65 145.54 87.65 129.84 101.24 122 101.24 137.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 129.84 74.06 122 87.65 114.15 101.24 122 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 129.84 74.64 122.34 74.06 122.68 87.65 130.53 101.24 122.68 100.65 122.34 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 91.71 147.77 105.3 155.62 118.9 147.77 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 155.62 91.71 147.77 91.71 132.07 105.3 139.92 105.3 155.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 147.77 105.3 155.62 105.3 139.92 118.9 132.07 118.9 147.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 105.3 124.22 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 139.92 91.71 132.07 91.71 132.75 105.3 140.6 118.9 132.75 118.31 132.41 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 109.37 157.84 122.96 165.69 136.55 157.84 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 165.69 109.37 157.84 109.37 142.15 122.96 149.99 122.96 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 157.84 122.96 165.69 122.96 149.99 136.55 142.15 136.55 157.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 122.96 134.3 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 149.99 109.37 142.15 109.37 142.83 122.96 150.67 136.55 142.83 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 126.14 149.03 120.79 158.31 115.44 167.58 120.79 158.31 126.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 127.38 78.38 122.03 87.65 116.67 96.92 122.03 87.65 127.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 87.51 109.37 79.66 109.37 95.35 122.96 103.2 136.55 95.35 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 103.2 109.37 95.35 109.37 79.66 122.96 87.51 122.96 103.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 95.35 122.96 103.2 122.96 87.51 136.55 79.66 136.55 95.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 87.51 109.37 79.66 122.96 71.81 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 87.51 109.37 79.66 109.37 80.34 122.96 88.19 136.55 80.34 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 97.58 127.02 89.73 127.02 105.43 140.62 113.28 154.21 105.43 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 113.28 127.02 105.43 127.02 89.73 140.62 97.58 140.62 113.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 105.43 140.62 113.28 140.62 97.58 154.21 89.73 154.21 105.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 97.58 127.02 89.73 140.62 81.88 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 97.58 127.02 89.73 127.02 90.41 140.62 98.26 154.21 90.41 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 107.65 144.68 99.81 144.68 115.5 158.27 123.35 171.87 115.5 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 123.35 144.68 115.5 144.68 99.81 158.27 107.65 158.27 123.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 115.5 158.27 123.35 158.27 107.65 171.87 99.81 171.87 115.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 107.65 144.68 99.81 158.27 91.96 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 107.65 144.68 99.81 144.68 100.49 158.27 108.33 171.87 100.49 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 98.26 91.71 90.41 91.71 106.11 105.3 113.96 118.9 106.11 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 113.96 91.71 106.11 91.71 90.41 105.3 98.26 105.3 113.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 106.11 105.3 113.96 105.3 98.26 118.9 90.41 118.9 106.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 98.26 91.71 90.41 105.3 82.56 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 98.26 91.71 90.41 91.71 91.09 105.3 98.94 118.9 91.09 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 109.02 74.06 101.17 74.06 116.86 87.65 124.71 101.24 116.86 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 124.71 74.06 116.86 74.06 101.17 87.65 109.02 87.65 124.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 116.86 87.65 124.71 87.65 109.02 101.24 101.17 101.24 116.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 109.02 74.06 101.17 87.65 93.32 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 109.02 74.06 101.17 74.06 101.85 87.65 109.7 101.24 101.85 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 193.86 109.37 186.01 109.37 201.71 122.96 209.56 136.55 201.71 136.55 186.01 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 209.56 109.37 201.71 109.37 186.01 122.96 193.86 122.96 209.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 201.71 122.96 209.56 122.96 193.86 136.55 186.01 136.55 201.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 193.86 109.37 186.01 122.96 178.16 136.55 186.01 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 193.86 109.96 186.35 109.37 186.69 122.96 194.54 136.55 186.69 135.96 186.35 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 203.93 127.02 196.09 127.02 211.78 140.62 219.63 154.21 211.78 154.21 196.09 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 219.63 127.02 211.78 127.02 196.09 140.62 203.93 140.62 219.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 211.78 140.62 219.63 140.62 203.93 154.21 196.09 154.21 211.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 203.93 127.02 196.09 140.62 188.24 154.21 196.09 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 203.93 127.61 196.43 127.02 196.77 140.62 204.62 154.21 196.77 153.62 196.43 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 214.01 144.68 206.16 144.68 221.86 158.27 229.7 171.87 221.86 171.87 206.16 158.27 214.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 229.7 144.68 221.86 144.68 206.16 158.27 214.01 158.27 229.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 221.86 158.27 229.7 158.27 214.01 171.87 206.16 171.87 221.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 214.01 144.68 206.16 158.27 198.31 171.87 206.16 158.27 214.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 214.01 145.27 206.5 144.68 206.84 158.27 214.69 171.87 206.84 171.87 206.16 158.27 214.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 204.62 91.71 196.77 91.71 212.46 105.3 220.31 118.9 212.46 118.9 196.77 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 220.31 91.71 212.46 91.71 196.77 105.3 204.62 105.3 220.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 212.46 105.3 220.31 105.3 204.62 118.9 196.77 118.9 212.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 204.62 91.71 196.77 105.3 188.92 118.9 196.77 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 204.62 92.3 197.11 91.71 197.45 105.3 205.3 118.9 197.45 118.31 197.11 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 214.69 109.37 206.84 109.37 222.54 122.96 230.38 136.55 222.54 136.55 206.84 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 230.38 109.37 222.54 109.37 206.84 122.96 214.69 122.96 230.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 222.54 122.96 230.38 122.96 214.69 136.55 206.84 136.55 222.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 214.69 109.37 206.84 122.96 198.99 136.55 206.84 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 214.69 109.96 207.18 109.37 207.52 122.96 215.37 136.55 207.52 135.96 207.18 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 224.76 127.02 216.91 127.02 232.61 140.62 240.46 154.21 232.61 154.21 216.91 140.62 224.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 240.46 127.02 232.61 127.02 216.91 140.62 224.76 140.62 240.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 232.61 140.62 240.46 140.62 224.76 154.21 216.91 154.21 232.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 224.76 127.02 216.91 140.62 209.07 154.21 216.92 140.62 224.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 224.76 127.61 217.26 127.02 217.6 140.62 225.44 154.21 217.6 154.21 216.91 140.62 224.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 215.37 74.06 207.52 74.06 223.22 87.65 231.06 101.24 223.22 101.24 207.52 87.65 215.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 231.06 74.06 223.22 74.06 207.52 87.65 215.37 87.65 231.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 223.22 87.65 231.06 87.65 215.37 101.24 207.52 101.24 223.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 215.37 74.06 207.52 87.65 199.67 101.24 207.52 87.65 215.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 215.37 74.06 207.52 74.06 208.2 87.65 216.05 101.24 208.2 100.65 207.86 87.65 215.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 225.44 91.71 217.6 91.71 233.29 105.3 241.14 118.9 233.29 118.9 217.6 105.3 225.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 241.14 91.71 233.29 91.71 217.6 105.3 225.44 105.3 241.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 233.29 105.3 241.14 105.3 225.44 118.9 217.6 118.9 233.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 225.44 91.71 217.6 105.3 209.75 118.9 217.6 105.3 225.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 225.44 91.71 217.6 91.71 218.28 105.3 226.13 118.9 218.28 118.31 217.94 105.3 225.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 235.52 109.37 227.67 109.37 243.37 122.96 251.21 136.55 243.37 136.55 227.67 122.96 235.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 251.21 109.37 243.37 109.37 227.67 122.96 235.52 122.96 251.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 243.37 122.96 251.21 122.96 235.52 136.55 227.67 136.55 243.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 235.52 109.37 227.67 122.96 219.82 136.55 227.67 122.96 235.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 235.52 109.37 227.67 109.37 228.35 122.96 236.2 136.55 228.35 136.55 227.67 122.96 235.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 173.03 109.37 165.18 109.37 180.88 122.96 188.73 136.55 180.88 136.55 165.18 122.96 173.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 188.73 109.37 180.88 109.37 165.18 122.96 173.03 122.96 188.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 180.88 122.96 188.73 122.96 173.03 136.55 165.18 136.55 180.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 173.03 109.37 165.18 122.96 157.34 136.55 165.18 122.96 173.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 173.03 109.96 165.52 109.37 165.86 122.96 173.71 136.55 165.86 135.96 165.52 122.96 173.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "122.96 232.96 113.69 227.61 122.96 222.25 132.23 227.61 122.96 232.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "105.3 222.89 96.03 217.53 105.3 212.18 114.58 217.53 105.3 222.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.62 222.21 131.34 216.85 140.62 211.5 149.89 216.85 140.62 222.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 211.57 149.03 206.22 158.31 200.87 167.58 206.22 158.31 211.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 212.81 78.38 207.46 87.65 202.11 96.92 207.46 87.65 212.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 183.1 127.02 175.26 127.02 190.95 140.62 198.8 154.21 190.95 154.21 175.26 140.62 183.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 198.8 127.02 190.95 127.02 175.26 140.62 183.1 140.62 198.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 190.95 140.62 198.8 140.62 183.1 154.21 175.26 154.21 190.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 183.1 127.02 175.26 140.62 167.41 154.21 175.26 140.62 183.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 183.1 127.61 175.6 127.02 175.94 140.62 183.79 154.21 175.94 153.62 175.6 140.62 183.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 193.18 144.68 185.33 144.68 201.03 158.27 208.87 171.87 201.03 171.87 185.33 158.27 193.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 208.87 144.68 201.03 144.68 185.33 158.27 193.18 158.27 208.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 201.03 158.27 208.87 158.27 193.18 171.87 185.33 171.87 201.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 193.18 144.68 185.33 158.27 177.48 171.87 185.33 158.27 193.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 193.18 145.27 185.67 144.68 186.01 158.27 193.86 171.87 186.01 171.87 185.33 158.27 193.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 183.79 91.71 175.94 91.71 191.63 105.3 199.48 118.9 191.63 118.9 175.94 105.3 183.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 199.48 91.71 191.63 91.71 175.94 105.3 183.79 105.3 199.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 191.63 105.3 199.48 105.3 183.79 118.9 175.94 118.9 191.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 183.79 91.71 175.94 105.3 168.09 118.9 175.94 105.3 183.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 183.79 92.3 176.28 91.71 176.62 105.3 184.47 118.9 176.62 118.31 176.28 105.3 183.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 193.86 109.37 186.01 109.37 201.71 122.96 209.56 136.55 201.71 136.55 186.01 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 209.56 109.37 201.71 109.37 186.01 122.96 193.86 122.96 209.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 201.71 122.96 209.56 122.96 193.86 136.55 186.01 136.55 201.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 193.86 109.37 186.01 122.96 178.16 136.55 186.01 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 193.86 109.96 186.35 109.37 186.69 122.96 194.54 136.55 186.69 135.96 186.35 122.96 193.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 203.93 127.02 196.09 127.02 211.78 140.62 219.63 154.21 211.78 154.21 196.09 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 219.63 127.02 211.78 127.02 196.09 140.62 203.93 140.62 219.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 211.78 140.62 219.63 140.62 203.93 154.21 196.09 154.21 211.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 203.93 127.02 196.09 140.62 188.24 154.21 196.09 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 203.93 127.61 196.43 127.02 196.77 140.62 204.62 154.21 196.77 154.21 196.09 140.62 203.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 194.54 74.06 186.69 74.06 202.39 87.65 210.24 101.24 202.39 101.24 186.69 87.65 194.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 210.24 74.06 202.39 74.06 186.69 87.65 194.54 87.65 210.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 202.39 87.65 210.24 87.65 194.54 101.24 186.69 101.24 202.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 194.54 74.06 186.69 87.65 178.84 101.24 186.69 87.65 194.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 194.54 74.64 187.03 74.06 187.37 87.65 195.22 101.24 187.37 100.65 187.03 87.65 194.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 204.62 91.71 196.77 91.71 212.46 105.3 220.31 118.9 212.46 118.9 196.77 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 220.31 91.71 212.46 91.71 196.77 105.3 204.62 105.3 220.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 212.46 105.3 220.31 105.3 204.62 118.9 196.77 118.9 212.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 204.62 91.71 196.77 105.3 188.92 118.9 196.77 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 204.62 91.71 196.77 91.71 197.45 105.3 205.3 118.9 197.45 118.31 197.11 105.3 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 214.69 109.37 206.84 109.37 222.54 122.96 230.38 136.55 222.54 136.55 206.84 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 230.38 109.37 222.54 109.37 206.84 122.96 214.69 122.96 230.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 222.54 122.96 230.38 122.96 214.69 136.55 206.84 136.55 222.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 214.69 109.37 206.84 122.96 198.99 136.55 206.84 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 214.69 109.37 206.84 109.37 207.52 122.96 215.37 136.55 207.52 136.55 206.84 122.96 214.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 190.84 149.03 185.49 158.31 180.13 167.58 185.49 158.31 190.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 192.08 78.38 186.72 87.65 181.37 96.92 186.72 87.65 192.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 152.2 109.37 144.35 109.37 160.05 122.96 167.9 136.55 160.05 136.55 144.35 122.96 152.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 167.9 109.37 160.05 109.37 144.35 122.96 152.2 122.96 167.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 160.05 122.96 167.9 122.96 152.2 136.55 144.35 136.55 160.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 152.2 109.37 144.35 122.96 136.51 136.55 144.35 122.96 152.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 152.2 109.37 144.35 109.37 145.03 122.96 152.88 136.55 145.03 136.55 144.35 122.96 152.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 162.28 127.02 154.43 127.02 170.12 140.62 177.97 154.21 170.12 154.21 154.43 140.62 162.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 177.97 127.02 170.12 127.02 154.43 140.62 162.28 140.62 177.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 170.12 140.62 177.97 140.62 162.28 154.21 154.43 154.21 170.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 162.28 127.02 154.43 140.62 146.58 154.21 154.43 140.62 162.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 162.28 127.02 154.43 127.02 155.11 140.62 162.96 154.21 155.11 154.21 154.43 140.62 162.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 172.35 144.68 164.5 144.68 180.2 158.27 188.04 171.87 180.2 171.87 164.5 158.27 172.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 188.04 144.68 180.2 144.68 164.5 158.27 172.35 158.27 188.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 180.2 158.27 188.04 158.27 172.35 171.87 164.5 171.87 180.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 172.35 144.68 164.5 158.27 156.65 171.87 164.5 158.27 172.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 172.35 144.68 164.5 144.68 165.18 158.27 173.03 171.87 165.18 171.87 164.5 158.27 172.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 162.96 91.71 155.11 91.71 170.8 105.3 178.65 118.9 170.8 118.9 155.11 105.3 162.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 178.65 91.71 170.8 91.71 155.11 105.3 162.96 105.3 178.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 170.8 105.3 178.65 105.3 162.96 118.9 155.11 118.9 170.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 162.96 91.71 155.11 105.3 147.26 118.9 155.11 105.3 162.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 162.96 91.71 155.11 91.71 155.79 105.3 163.64 118.9 155.79 118.9 155.11 105.3 162.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 173.71 74.06 165.86 74.06 181.56 87.65 189.41 101.24 181.56 101.24 165.86 87.65 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 189.41 74.06 181.56 74.06 165.86 87.65 173.71 87.65 189.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 181.56 87.65 189.41 87.65 173.71 101.24 165.86 101.24 181.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 173.71 74.06 165.86 87.65 158.02 101.24 165.86 87.65 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 173.71 74.06 165.86 74.06 166.54 87.65 174.39 101.24 166.54 101.24 165.86 87.65 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 173.37 109.37 165.52 109.37 181.22 122.96 189.07 136.55 181.22 136.55 165.52 122.96 173.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 189.07 109.37 181.22 109.37 165.52 122.96 173.37 122.96 189.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 181.22 122.96 189.07 122.96 173.37 136.55 165.52 136.55 181.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 173.37 109.37 165.52 122.96 157.68 136.55 165.52 122.96 173.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 173.37 109.96 165.86 109.37 166.2 122.96 174.05 136.55 166.2 135.96 165.86 122.96 173.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 183.44 127.02 175.6 127.02 191.29 140.62 199.14 154.21 191.29 154.21 175.6 140.62 183.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 199.14 127.02 191.29 127.02 175.6 140.62 183.44 140.62 199.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 191.29 140.62 199.14 140.62 183.44 154.21 175.6 154.21 191.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 183.44 127.02 175.6 140.62 167.75 154.21 175.6 140.62 183.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 183.44 127.61 175.94 127.02 176.28 140.62 184.13 154.21 176.28 154.21 175.6 140.62 183.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 184.13 91.71 176.28 91.71 191.97 105.3 199.82 118.9 191.97 118.9 176.28 105.3 184.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 199.82 91.71 191.97 91.71 176.28 105.3 184.13 105.3 199.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 191.97 105.3 199.82 105.3 184.13 118.9 176.28 118.9 191.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 184.13 91.71 176.28 105.3 168.43 118.9 176.28 105.3 184.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 184.13 91.71 176.28 91.71 176.96 105.3 184.81 118.9 176.96 118.9 176.28 105.3 184.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 194.2 109.37 186.35 109.37 202.05 122.96 209.9 136.55 202.05 136.55 186.35 122.96 194.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 209.9 109.37 202.05 109.37 186.35 122.96 194.2 122.96 209.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 202.05 122.96 209.9 122.96 194.2 136.55 186.35 136.55 202.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 194.2 109.37 186.35 122.96 178.5 136.55 186.35 122.96 194.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 194.2 109.37 186.35 109.37 187.03 122.96 194.88 136.55 187.03 136.55 186.35 122.96 194.2"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M426.73,298a6,6,0,0,1-2.89-.73L293.15,221.77a2.3,2.3,0,0,1-1.34-1.85,1.74,1.74,0,0,1,1-1.48l78-45a5.67,5.67,0,0,1,5.14.2l130.7,75.46a2.3,2.3,0,0,1,1.34,1.85,1.74,1.74,0,0,1-1,1.48l-78,45A4.66,4.66,0,0,1,426.73,298ZM373.05,173.5a4,4,0,0,0-1.95.45l-78,45a1.18,1.18,0,0,0-.69.94,1.71,1.71,0,0,0,1,1.31h0l130.7,75.46a5,5,0,0,0,4.53.2l78-45a1.17,1.17,0,0,0,.68-.94,1.69,1.69,0,0,0-1-1.31l-130.7-75.46A5.29,5.29,0,0,0,373.05,173.5Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.3,223.69,424,299.15a5.34,5.34,0,0,0,4.83.2l78-45a1.56,1.56,0,0,0,.78-.91,1.33,1.33,0,0,1-.78,1.5l-78,45a5.4,5.4,0,0,1-4.83-.2L293.3,224.28c-.93-.54-1.31-1.25-1.13-1.88A2.16,2.16,0,0,0,293.3,223.69Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M472.46,219.58,435,197.93c-3.81-2.2-3.81-5.78,0-8l37.51-21.65a15.27,15.27,0,0,1,13.81,0L523.78,190c3.81,2.2,3.81,5.78,0,8l-37.51,21.65A15.27,15.27,0,0,1,472.46,219.58Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 91.43 175.93 83.58 175.93 99.28 189.52 107.13 203.12 99.28 203.12 83.58 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 107.13 175.93 99.28 175.93 83.58 189.52 91.43 189.52 107.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 99.28 189.52 107.13 189.52 91.43 203.12 83.58 203.12 99.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 91.43 175.93 83.58 189.52 75.73 203.12 83.58 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 91.43 176.52 83.92 175.93 84.26 189.52 92.11 203.12 84.26 202.53 83.92 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 101.5 193.59 93.66 193.59 109.35 207.18 117.2 220.77 109.35 220.77 93.66 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 117.2 193.59 109.35 193.59 93.66 207.18 101.5 207.18 117.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.77 109.35 207.18 117.2 207.18 101.5 220.77 93.66 220.77 109.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 101.5 193.59 93.66 207.18 85.81 220.77 93.66 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.18 101.5 194.18 94 193.59 94.34 207.18 102.18 220.77 94.34 220.18 94 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 111.58 211.24 103.73 211.24 119.42 224.84 127.27 238.43 119.42 238.43 103.73 224.84 111.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 127.27 211.24 119.42 211.24 103.73 224.84 111.58 224.84 127.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "238.43 119.42 224.84 127.27 224.84 111.58 238.43 103.73 238.43 119.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 111.58 211.24 103.73 224.83 95.88 238.43 103.73 224.84 111.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.84 111.58 211.83 104.07 211.24 104.41 224.84 112.26 238.43 104.41 238.43 103.73 224.84 111.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 102.18 158.27 94.34 158.27 110.03 171.87 117.88 185.46 110.03 185.46 94.34 171.87 102.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 117.88 158.27 110.03 158.27 94.34 171.87 102.18 171.87 117.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 110.03 171.87 117.88 171.87 102.18 185.46 94.34 185.46 110.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 102.18 158.27 94.34 171.87 86.49 185.46 94.34 171.87 102.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 102.18 158.86 94.68 158.27 95.02 171.87 102.86 185.46 95.02 184.87 94.68 171.87 102.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 112.26 175.93 104.41 175.93 120.11 189.52 127.95 203.12 120.11 203.12 104.41 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 127.95 175.93 120.11 175.93 104.41 189.52 112.26 189.52 127.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 120.11 189.52 127.95 189.52 112.26 203.12 104.41 203.12 120.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 112.26 175.93 104.41 189.52 96.56 203.12 104.41 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 112.26 176.52 104.75 175.93 105.09 189.52 112.94 203.12 105.09 202.53 104.75 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 122.33 193.59 114.48 193.59 130.18 207.18 138.03 220.77 130.18 220.77 114.48 207.18 122.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 138.03 193.59 130.18 193.59 114.48 207.18 122.33 207.18 138.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.77 130.18 207.18 138.03 207.18 122.33 220.77 114.48 220.77 130.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 122.33 193.59 114.48 207.18 106.64 220.77 114.48 207.18 122.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.18 122.33 194.18 114.83 193.59 115.17 207.18 123.01 220.77 115.17 220.77 114.48 207.18 122.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 112.94 140.62 105.09 140.62 120.79 154.21 128.63 167.8 120.79 167.8 105.09 154.21 112.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 128.63 140.62 120.79 140.62 105.09 154.21 112.94 154.21 128.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "167.8 120.79 154.21 128.63 154.21 112.94 167.8 105.09 167.8 120.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 112.94 140.62 105.09 154.21 97.24 167.8 105.09 154.21 112.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.21 112.94 140.62 105.09 140.62 105.77 154.21 113.62 167.8 105.77 167.21 105.43 154.21 112.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 123.01 158.27 115.17 158.27 130.86 171.87 138.71 185.46 130.86 185.46 115.17 171.87 123.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 138.71 158.27 130.86 158.27 115.17 171.87 123.01 171.87 138.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 130.86 171.87 138.71 171.87 123.01 185.46 115.17 185.46 130.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 123.01 158.27 115.17 171.87 107.32 185.46 115.17 171.87 123.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 123.01 158.27 115.17 158.27 115.85 171.87 123.69 185.46 115.85 184.87 115.51 171.87 123.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 133.09 175.93 125.24 175.93 140.94 189.52 148.78 203.12 140.94 203.12 125.24 189.52 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 148.78 175.93 140.94 175.93 125.24 189.52 133.09 189.52 148.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 140.94 189.52 148.78 189.52 133.09 203.12 125.24 203.12 140.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 133.09 175.93 125.24 189.52 117.39 203.12 125.24 189.52 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 133.09 175.93 125.24 175.93 125.92 189.52 133.77 203.12 125.92 203.12 125.24 189.52 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 70.6 175.93 62.75 175.93 78.45 189.52 86.3 203.12 78.45 203.12 62.75 189.52 70.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 86.3 175.93 78.45 175.93 62.75 189.52 70.6 189.52 86.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 78.45 189.52 86.3 189.52 70.6 203.12 62.75 203.12 78.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 70.6 175.93 62.75 189.52 54.91 203.12 62.75 189.52 70.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 70.6 176.52 63.09 175.93 63.43 189.52 71.28 203.12 63.43 202.53 63.09 189.52 70.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.52 130.53 180.25 125.18 189.52 119.83 198.79 125.18 189.52 130.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "171.87 120.46 162.59 115.1 171.87 109.75 181.14 115.1 171.87 120.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "207.18 119.78 197.91 114.42 207.18 109.07 216.45 114.42 207.18 119.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "224.87 109.14 215.6 103.79 224.87 98.44 234.14 103.79 224.87 109.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "154.21 110.38 144.94 105.03 154.21 99.68 163.48 105.03 154.21 110.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 80.67 193.59 72.83 193.59 88.52 207.18 96.37 220.77 88.52 220.77 72.83 207.18 80.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 96.37 193.59 88.52 193.59 72.83 207.18 80.67 207.18 96.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.77 88.52 207.18 96.37 207.18 80.67 220.77 72.83 220.77 88.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 80.67 193.59 72.83 207.18 64.98 220.77 72.83 207.18 80.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.18 80.67 194.18 73.17 193.59 73.51 207.18 81.36 220.77 73.51 220.18 73.17 207.18 80.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 90.75 211.24 82.9 211.24 98.6 224.84 106.44 238.43 98.6 238.43 82.9 224.84 90.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 106.44 211.24 98.6 211.24 82.9 224.84 90.75 224.84 106.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "238.43 98.6 224.84 106.44 224.84 90.75 238.43 82.9 238.43 98.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "224.84 90.75 211.24 82.9 224.83 75.05 238.43 82.9 224.84 90.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.84 90.75 211.83 83.24 211.24 83.58 224.84 91.43 238.43 83.58 238.43 82.9 224.84 90.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 81.36 158.27 73.51 158.27 89.2 171.87 97.05 185.46 89.2 185.46 73.51 171.87 81.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 97.05 158.27 89.2 158.27 73.51 171.87 81.36 171.87 97.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 89.2 171.87 97.05 171.87 81.36 185.46 73.51 185.46 89.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 81.36 158.27 73.51 171.87 65.66 185.46 73.51 171.87 81.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 81.36 158.86 73.85 158.27 74.19 171.87 82.04 185.46 74.19 184.87 73.85 171.87 81.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 91.43 175.93 83.58 175.93 99.28 189.52 107.13 203.12 99.28 203.12 83.58 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 107.13 175.93 99.28 175.93 83.58 189.52 91.43 189.52 107.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 99.28 189.52 107.13 189.52 91.43 203.12 83.58 203.12 99.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 91.43 175.93 83.58 189.52 75.73 203.12 83.58 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 91.43 176.52 83.92 175.93 84.26 189.52 92.11 203.12 84.26 202.53 83.92 189.52 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 101.5 193.59 93.66 193.59 109.35 207.18 117.2 220.77 109.35 220.77 93.66 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 117.2 193.59 109.35 193.59 93.66 207.18 101.5 207.18 117.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.77 109.35 207.18 117.2 207.18 101.5 220.77 93.66 220.77 109.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.18 101.5 193.59 93.66 207.18 85.81 220.77 93.66 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.18 101.5 194.18 94 193.59 94.34 207.18 102.18 220.77 94.34 220.77 93.66 207.18 101.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 92.11 140.62 84.26 140.62 99.96 154.21 107.81 167.8 99.96 167.8 84.26 154.21 92.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 107.81 140.62 99.96 140.62 84.26 154.21 92.11 154.21 107.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "167.8 99.96 154.21 107.81 154.21 92.11 167.8 84.26 167.8 99.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 92.11 140.62 84.26 154.21 76.42 167.8 84.26 154.21 92.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.21 92.11 141.21 84.6 140.62 84.94 154.21 92.79 167.8 84.94 167.21 84.6 154.21 92.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 102.19 158.27 94.34 158.27 110.03 171.87 117.88 185.46 110.03 185.46 94.34 171.87 102.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 117.88 158.27 110.03 158.27 94.34 171.87 102.19 171.87 117.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 110.03 171.87 117.88 171.87 102.19 185.46 94.34 185.46 110.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 102.19 158.27 94.34 171.87 86.49 185.46 94.34 171.87 102.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 102.19 158.27 94.34 158.27 95.02 171.87 102.86 185.46 95.02 184.87 94.68 171.87 102.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 112.26 175.93 104.41 175.93 120.11 189.52 127.95 203.12 120.11 203.12 104.41 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 127.95 175.93 120.11 175.93 104.41 189.52 112.26 189.52 127.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 120.11 189.52 127.95 189.52 112.26 203.12 104.41 203.12 120.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 112.26 175.93 104.41 189.52 96.56 203.12 104.41 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 112.26 175.93 104.41 175.93 105.09 189.52 112.94 203.12 105.09 203.12 104.41 189.52 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "154.21 89.65 144.94 84.29 154.21 78.94 163.48 84.29 154.21 89.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 49.77 175.93 41.92 175.93 57.62 189.52 65.47 203.12 57.62 203.12 41.92 189.52 49.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 65.47 175.93 57.62 175.93 41.92 189.52 49.77 189.52 65.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 57.62 189.52 65.47 189.52 49.77 203.12 41.92 203.12 57.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 49.77 175.93 41.92 189.52 34.08 203.12 41.92 189.52 49.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 49.77 175.93 41.92 175.93 42.6 189.52 50.45 203.12 42.6 203.12 41.92 189.52 49.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 60.53 158.27 52.68 158.27 68.37 171.87 76.22 185.46 68.37 185.46 52.68 171.87 60.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 76.22 158.27 68.37 158.27 52.68 171.87 60.53 171.87 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 68.37 171.87 76.22 171.87 60.53 185.46 52.68 185.46 68.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 60.53 158.27 52.68 171.87 44.83 185.46 52.68 171.87 60.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 60.53 158.27 52.68 158.27 53.36 171.87 61.21 185.46 53.36 185.46 52.68 171.87 60.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 71.28 140.62 63.43 140.62 79.13 154.21 86.98 167.8 79.13 167.8 63.43 154.21 71.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 86.98 140.62 79.13 140.62 63.43 154.21 71.28 154.21 86.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "167.8 79.13 154.21 86.98 154.21 71.28 167.8 63.43 167.8 79.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "154.21 71.28 140.62 63.43 154.21 55.59 167.8 63.43 154.21 71.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.21 71.28 140.62 63.43 140.62 64.11 154.21 71.96 167.8 64.11 167.8 63.43 154.21 71.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 82.01 158.27 74.16 158.27 89.85 171.87 97.7 185.46 89.85 185.46 74.16 171.87 82.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 97.7 158.27 89.85 158.27 74.16 171.87 82.01 171.87 97.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.46 89.85 171.87 97.7 171.87 82.01 185.46 74.16 185.46 89.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "171.87 82.01 158.27 74.16 171.87 66.31 185.46 74.16 171.87 82.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.87 82.01 158.27 74.16 158.27 74.84 171.87 82.69 185.46 74.84 185.46 74.16 171.87 82.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 92.08 175.93 84.23 175.93 99.93 189.52 107.78 203.12 99.93 203.12 84.23 189.52 92.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 107.78 175.93 99.93 175.93 84.23 189.52 92.08 189.52 107.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.12 99.93 189.52 107.78 189.52 92.08 203.12 84.23 203.12 99.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "189.52 92.08 175.93 84.23 189.52 76.38 203.12 84.23 189.52 92.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.52 92.08 175.93 84.23 175.93 84.91 189.52 92.76 203.12 84.91 203.12 84.23 189.52 92.08"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M502,156.56a1.89,1.89,0,0,1-1-.28,2.82,2.82,0,0,1-1.36-2.85,1.45,1.45,0,0,1,.82-1,1.67,1.67,0,0,1,1.53.17,2.78,2.78,0,0,1,1.36,2.85,1.43,1.43,0,0,1-.81,1A1.58,1.58,0,0,1,502,156.56Zm-.93-3.84a1.06,1.06,0,0,0-.4.08,1,1,0,0,0-.55.72,2.36,2.36,0,0,0,1.14,2.38,1.29,1.29,0,0,0,1.14.14,1,1,0,0,0,.56-.73,2.38,2.38,0,0,0-1.15-2.37A1.53,1.53,0,0,0,501.08,152.72Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M507.3,159.61a1.89,1.89,0,0,1-1-.28,2.8,2.8,0,0,1-1.35-2.85,1.43,1.43,0,0,1,.81-1,1.72,1.72,0,0,1,1.54.17,2.78,2.78,0,0,1,1.35,2.85,1.43,1.43,0,0,1-.81,1A1.56,1.56,0,0,1,507.3,159.61Zm-.94-3.84a1,1,0,0,0-.95.81,2.37,2.37,0,0,0,1.14,2.37,1.29,1.29,0,0,0,1.14.14,1,1,0,0,0,.56-.73A2.36,2.36,0,0,0,507.1,156,1.53,1.53,0,0,0,506.36,155.77Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M513.75,161.46a1.26,1.26,0,0,1-2,.73,2.56,2.56,0,0,1-1.25-2.61,1.26,1.26,0,0,1,2-.73A2.6,2.6,0,0,1,513.75,161.46Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "131.55 32.74 128.72 31.11 128.94 29.8 131.77 31.43 131.55 32.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "135.66 35.11 132.83 33.48 133.05 32.17 135.88 33.81 135.66 35.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "127.49 30.39 121.29 26.82 121.51 25.51 127.7 29.09 127.49 30.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M403.86,275.33l-.11-.06-65.13-37.6L403.86,200l.11.07,65.12,37.6Zm-64.35-37.66,64.35,37.15,64.35-37.15-64.35-37.16Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M373.45,220.63a.2.2,0,0,1-.11,0l-.21-.12a.21.21,0,1,1,.22-.36l.2.12a.21.21,0,0,1,.07.29A.21.21,0,0,1,373.45,220.63Zm-3.95-2.37a.19.19,0,0,1-.1,0L365.66,216a.2.2,0,0,1-.07-.28.21.21,0,0,1,.28-.08l3.74,2.25a.21.21,0,0,1,.07.29A.22.22,0,0,1,369.5,218.26Zm-7.47-4.5a.23.23,0,0,1-.11,0l-3.73-2.24a.21.21,0,0,1-.07-.29.2.2,0,0,1,.28-.07l3.74,2.25a.2.2,0,0,1-.11.38Zm-7.47-4.49a.2.2,0,0,1-.11,0L350.71,207a.2.2,0,0,1-.07-.28.22.22,0,0,1,.29-.08l3.73,2.25a.21.21,0,0,1-.1.39Zm-7.48-4.5-.1,0-3.74-2.25a.21.21,0,0,1-.07-.29.2.2,0,0,1,.28-.07l3.74,2.25a.2.2,0,0,1-.11.38Zm-7.47-4.49a.23.23,0,0,1-.11,0L335.77,198a.2.2,0,1,1,.21-.35l3.74,2.24a.21.21,0,0,1,.07.29A.22.22,0,0,1,339.61,200.28Zm-7.47-4.49a.2.2,0,0,1-.11,0l-3.74-2.25a.21.21,0,0,1-.07-.29.22.22,0,0,1,.29-.07l3.73,2.25a.21.21,0,0,1,.08.28A.21.21,0,0,1,332.14,195.79Zm-7.48-4.5a.19.19,0,0,1-.1,0L320.82,189a.2.2,0,0,1-.07-.28.2.2,0,0,1,.28-.07l3.74,2.24a.21.21,0,0,1,.07.29A.22.22,0,0,1,324.66,191.29Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 109.37 137.01 122.96 144.86 136.55 137.01 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 144.86 109.37 137.01 109.37 121.32 122.96 129.16 122.96 144.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 137.01 122.96 144.86 122.96 129.16 136.55 121.32 136.55 137.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 122.96 113.47 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 129.16 109.96 121.66 109.37 122 122.96 129.84 136.55 122 135.96 121.66 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 127.02 147.09 140.62 154.93 154.21 147.09 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 154.93 127.02 147.09 127.02 131.39 140.62 139.24 140.62 154.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 147.09 140.62 154.93 140.62 139.24 154.21 131.39 154.21 147.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 140.62 123.54 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 139.24 127.61 131.73 127.02 132.07 140.62 139.92 154.21 132.07 153.62 131.73 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 149.31 144.68 141.47 144.68 157.16 158.27 165.01 171.87 157.16 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 165.01 144.68 157.16 144.68 141.47 158.27 149.31 158.27 165.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 157.16 158.27 165.01 158.27 149.31 171.87 141.47 171.87 157.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 149.31 144.68 141.47 158.27 133.62 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 149.31 145.27 141.81 144.68 142.15 158.27 149.99 171.87 142.15 171.87 141.47 158.27 149.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 91.71 147.77 105.3 155.61 118.9 147.77 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 155.61 91.71 147.77 91.71 132.07 105.3 139.92 105.3 155.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 147.77 105.3 155.61 105.3 139.92 118.9 132.07 118.9 147.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 105.3 124.22 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 139.92 92.3 132.41 91.71 132.75 105.3 140.6 118.9 132.75 118.31 132.41 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 109.37 157.84 122.96 165.69 136.55 157.84 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 165.69 109.37 157.84 109.37 142.15 122.96 149.99 122.96 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 157.84 122.96 165.69 122.96 149.99 136.55 142.15 136.55 157.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 122.96 134.3 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 149.99 109.96 142.49 109.37 142.83 122.96 150.67 136.55 142.83 135.96 142.49 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 160.07 127.02 152.22 127.02 167.91 140.62 175.76 154.21 167.91 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 175.76 127.02 167.91 127.02 152.22 140.62 160.07 140.62 175.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 167.91 140.62 175.76 140.62 160.07 154.21 152.22 154.21 167.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 160.07 127.02 152.22 140.62 144.37 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 160.07 127.61 152.56 127.02 152.9 140.62 160.75 154.21 152.9 154.21 152.22 140.62 160.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 150.67 74.06 142.83 74.06 158.52 87.65 166.37 101.24 158.52 101.24 142.83 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 166.37 74.06 158.52 74.06 142.83 87.65 150.67 87.65 166.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 158.52 87.65 166.37 87.65 150.67 101.24 142.83 101.24 158.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 150.67 74.06 142.83 87.65 134.98 101.24 142.83 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 150.67 74.06 142.83 74.06 143.51 87.65 151.35 101.24 143.51 100.65 143.17 87.65 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 160.75 91.71 152.9 91.71 168.6 105.3 176.44 118.9 168.6 118.9 152.9 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 176.44 91.71 168.6 91.71 152.9 105.3 160.75 105.3 176.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 168.6 105.3 176.44 105.3 160.75 118.9 152.9 118.9 168.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 160.75 91.71 152.9 105.3 145.05 118.9 152.9 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 160.75 91.71 152.9 91.71 153.58 105.3 161.43 118.9 153.58 118.31 153.24 105.3 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 170.82 109.37 162.97 109.37 178.67 122.96 186.52 136.55 178.67 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 186.52 109.37 178.67 109.37 162.97 122.96 170.82 122.96 186.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 178.67 122.96 186.52 122.96 170.82 136.55 162.97 136.55 178.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 170.82 109.37 162.97 122.96 155.13 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 170.82 109.37 162.97 109.37 163.66 122.96 171.5 136.55 163.66 136.55 162.97 122.96 170.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 108.33 109.37 100.49 109.37 116.18 122.96 124.03 136.55 116.18 136.55 100.49 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 124.03 109.37 116.18 109.37 100.49 122.96 108.33 122.96 124.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 116.18 122.96 124.03 122.96 108.33 136.55 100.49 136.55 116.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 108.33 109.37 100.49 122.96 92.64 136.55 100.49 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 108.33 109.96 100.83 109.37 101.17 122.96 109.02 136.55 101.17 135.96 100.83 122.96 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "122.96 168.27 113.69 162.91 122.96 157.56 132.23 162.91 122.96 168.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "105.3 158.19 96.03 152.84 105.3 147.49 114.58 152.84 105.3 158.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.62 157.51 131.34 152.16 140.62 146.81 149.89 152.16 140.62 157.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 146.88 149.03 141.53 158.31 136.17 167.58 141.53 158.31 146.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 148.12 78.38 142.76 87.65 137.41 96.92 142.76 87.65 148.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 118.41 127.02 110.56 127.02 126.26 140.62 134.1 154.21 126.26 154.21 110.56 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 134.1 127.02 126.26 127.02 110.56 140.62 118.41 140.62 134.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 126.26 140.62 134.1 140.62 118.41 154.21 110.56 154.21 126.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 118.41 127.02 110.56 140.62 102.71 154.21 110.56 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 118.41 127.61 110.9 127.02 111.24 140.62 119.09 154.21 111.24 153.62 110.9 140.62 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 128.48 144.68 120.64 144.68 136.33 158.27 144.18 171.87 136.33 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 144.18 144.68 136.33 144.68 120.64 158.27 128.48 158.27 144.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 136.33 158.27 144.18 158.27 128.48 171.87 120.64 171.87 136.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 128.48 144.68 120.64 158.27 112.79 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 128.48 145.27 120.98 144.68 121.32 158.27 129.16 171.87 121.32 171.87 120.64 158.27 128.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 119.09 91.71 111.24 91.71 126.94 105.3 134.78 118.9 126.94 118.9 111.24 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 134.78 91.71 126.94 91.71 111.24 105.3 119.09 105.3 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 126.94 105.3 134.78 105.3 119.09 118.9 111.24 118.9 126.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 119.09 91.71 111.24 105.3 103.39 118.9 111.24 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 119.09 92.3 111.58 91.71 111.92 105.3 119.77 118.9 111.92 118.31 111.58 105.3 119.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 109.37 137.01 122.96 144.86 136.55 137.01 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 144.86 109.37 137.01 109.37 121.32 122.96 129.16 122.96 144.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 137.01 122.96 144.86 122.96 129.16 136.55 121.32 136.55 137.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 129.16 109.37 121.32 122.96 113.47 136.55 121.32 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 129.16 109.96 121.66 109.37 122 122.96 129.84 136.55 122 135.96 121.66 122.96 129.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 127.02 147.09 140.62 154.93 154.21 147.09 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 154.93 127.02 147.09 127.02 131.39 140.62 139.24 140.62 154.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 147.09 140.62 154.93 140.62 139.24 154.21 131.39 154.21 147.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 139.24 127.02 131.39 140.62 123.54 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 139.24 127.61 131.73 127.02 132.07 140.62 139.92 154.21 132.07 154.21 131.39 140.62 139.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 129.84 74.06 122 74.06 137.69 87.65 145.54 101.24 137.69 101.24 122 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 145.54 74.06 137.69 74.06 122 87.65 129.84 87.65 145.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 137.69 87.65 145.54 87.65 129.84 101.24 122 101.24 137.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 129.84 74.06 122 87.65 114.15 101.24 122 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 129.84 74.64 122.34 74.06 122.68 87.65 130.53 101.24 122.68 100.65 122.34 87.65 129.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 91.71 147.77 105.3 155.62 118.9 147.77 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 155.62 91.71 147.77 91.71 132.07 105.3 139.92 105.3 155.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 147.77 105.3 155.62 105.3 139.92 118.9 132.07 118.9 147.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 139.92 91.71 132.07 105.3 124.22 118.9 132.07 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 139.92 91.71 132.07 91.71 132.75 105.3 140.6 118.9 132.75 118.31 132.41 105.3 139.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 109.37 157.84 122.96 165.69 136.55 157.84 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 165.69 109.37 157.84 109.37 142.15 122.96 149.99 122.96 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 157.84 122.96 165.69 122.96 149.99 136.55 142.15 136.55 157.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 149.99 109.37 142.15 122.96 134.3 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 149.99 109.37 142.15 109.37 142.83 122.96 150.67 136.55 142.83 136.55 142.15 122.96 149.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.31 126.14 149.03 120.79 158.31 115.44 167.58 120.79 158.31 126.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "87.65 127.38 78.38 122.03 87.65 116.67 96.92 122.03 87.65 127.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 87.51 109.37 79.66 109.37 95.35 122.96 103.2 136.55 95.35 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 103.2 109.37 95.35 109.37 79.66 122.96 87.51 122.96 103.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "136.55 95.35 122.96 103.2 122.96 87.51 136.55 79.66 136.55 95.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "122.96 87.51 109.37 79.66 122.96 71.81 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "122.96 87.51 109.37 79.66 109.37 80.34 122.96 88.19 136.55 80.34 136.55 79.66 122.96 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 97.58 127.02 89.73 127.02 105.43 140.62 113.28 154.21 105.43 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 113.28 127.02 105.43 127.02 89.73 140.62 97.58 140.62 113.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "154.21 105.43 140.62 113.28 140.62 97.58 154.21 89.73 154.21 105.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "140.62 97.58 127.02 89.73 140.62 81.88 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.62 97.58 127.02 89.73 127.02 90.41 140.62 98.26 154.21 90.41 154.21 89.73 140.62 97.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 107.65 144.68 99.81 144.68 115.5 158.27 123.35 171.87 115.5 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 123.35 144.68 115.5 144.68 99.81 158.27 107.65 158.27 123.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "171.87 115.5 158.27 123.35 158.27 107.65 171.87 99.81 171.87 115.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "158.27 107.65 144.68 99.81 158.27 91.96 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "158.27 107.65 144.68 99.81 144.68 100.49 158.27 108.33 171.87 100.49 171.87 99.81 158.27 107.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 98.26 91.71 90.41 91.71 106.11 105.3 113.96 118.9 106.11 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 113.96 91.71 106.11 91.71 90.41 105.3 98.26 105.3 113.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "118.9 106.11 105.3 113.96 105.3 98.26 118.9 90.41 118.9 106.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "105.3 98.26 91.71 90.41 105.3 82.56 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.3 98.26 91.71 90.41 91.71 91.09 105.3 98.94 118.9 91.09 118.9 90.41 105.3 98.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 109.02 74.06 101.17 74.06 116.86 87.65 124.71 101.24 116.86 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 124.71 74.06 116.86 74.06 101.17 87.65 109.02 87.65 124.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.24 116.86 87.65 124.71 87.65 109.02 101.24 101.17 101.24 116.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.65 109.02 74.06 101.17 87.65 93.32 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.65 109.02 74.06 101.17 74.06 101.85 87.65 109.7 101.24 101.85 101.24 101.17 87.65 109.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M291.28,204.25a16.25,16.25,0,0,1-3.61-.41.22.22,0,0,1-.16-.25.21.21,0,0,1,.25-.16,15.53,15.53,0,0,0,3.52.41,6.21,6.21,0,0,0,.75,0c.14,0,.22.08.22.19a.2.2,0,0,1-.19.22c-.26,0-.51,0-.77,0Zm5-1a.21.21,0,0,1-.19-.12.2.2,0,0,1,.1-.28l.48-.26,3.78-2.18a.21.21,0,0,1,.28.08.2.2,0,0,1-.07.28L296.87,203c-.16.1-.34.19-.51.28Zm-12.57-1.07a.2.2,0,0,1-.11,0,5.52,5.52,0,0,1-2.69-3.49.21.21,0,1,1,.41-.07,5.11,5.11,0,0,0,2.51,3.21.22.22,0,0,1,.06.29A.21.21,0,0,1,283.7,202.19Zm20.62-3.56a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.29l3.77-2.18a.21.21,0,0,1,.29.08.21.21,0,0,1-.08.28l-3.78,2.18A.17.17,0,0,1,304.32,198.63Zm-21.22-3.36a.18.18,0,0,1-.17-.1.19.19,0,0,1,.06-.28l.15-.09,3.63-2.1a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3.63,2.1-.14.08A.2.2,0,0,1,283.1,195.27Zm28.77-1a.21.21,0,0,1-.1-.39l3.78-2.18a.21.21,0,0,1,.28.08.2.2,0,0,1-.08.28L312,194.24A.23.23,0,0,1,311.87,194.27Zm-21.22-3.36a.21.21,0,0,1-.1-.39l3.78-2.18a.2.2,0,0,1,.28.08.2.2,0,0,1-.08.28l-3.77,2.18A.2.2,0,0,1,290.65,190.91Zm28.78-1a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.78-2.18a.21.21,0,0,1,.28.08.2.2,0,0,1-.07.28l-3.78,2.18A.19.19,0,0,1,319.43,189.91Zm-21.22-3.36a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.78-2.18a.21.21,0,0,1,.21.36l-3.78,2.18A.19.19,0,0,1,298.21,186.55Zm28.77-1a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.78-2.18a.2.2,0,0,1,.28.08.2.2,0,0,1-.07.28l-3.78,2.18A.19.19,0,0,1,327,185.55Zm-21.22-3.36a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.29l3.77-2.18a.21.21,0,0,1,.29.08.21.21,0,0,1-.08.28l-3.78,2.18A.19.19,0,0,1,305.76,182.19Zm28.77-1a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.29l3.77-2.18a.21.21,0,0,1,.29.08.21.21,0,0,1-.08.28l-3.78,2.18A.17.17,0,0,1,334.53,181.19Zm-21.22-3.36a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.28l3.77-2.18a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3.77,2.18A.23.23,0,0,1,313.31,177.83Zm28.77-1a.22.22,0,0,1-.18-.1.2.2,0,0,1,.06-.28,3.37,3.37,0,0,0,1.71-2.76,2.6,2.6,0,0,0-.1-.72.21.21,0,0,1,.15-.25.22.22,0,0,1,.26.15,3.29,3.29,0,0,1,.1.82,3.73,3.73,0,0,1-1.89,3.1A.21.21,0,0,1,342.08,176.82Zm-21.22-3.35a.21.21,0,0,1-.1-.39l3.78-2.18a.21.21,0,0,1,.2.36L321,173.44A.2.2,0,0,1,320.86,173.47ZM341,169.9a.2.2,0,0,1-.11,0l-.21-.13a13.35,13.35,0,0,0-3.78-1.41.21.21,0,0,1-.16-.24.2.2,0,0,1,.25-.16,13.59,13.59,0,0,1,3.9,1.45l.22.13a.22.22,0,0,1,.07.29A.22.22,0,0,1,341,169.9Zm-12.58-.79a.21.21,0,0,1-.19-.11.21.21,0,0,1,.09-.28,10.91,10.91,0,0,1,4.28-1.11.21.21,0,0,1,.22.19.2.2,0,0,1-.19.22,10.56,10.56,0,0,0-4.11,1.07Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M343.87,110.68v54.07h0a3.75,3.75,0,0,1-2.18,3.12l-44.92,25.94c-3.24,1.87-8.88,1.63-12.62-.52h0c-2.09-1.21-3.14-2.77-3.08-4.23h0V135Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M296.77,139.74l44.92-25.93c3.24-1.87,2.83-5.13-.9-7.29h0c-3.74-2.15-9.39-2.39-12.62-.52l-44.92,25.94c-3.24,1.86-2.83,5.13.9,7.28h0C287.89,141.38,293.53,141.61,296.77,139.74Z",
    transform: "translate(-280.9 -70.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M292.28,136.27a3.89,3.89,0,0,0,3.89-3.89v-24c0-8.19,6-18.57,13.09-22.67l10.3-6c2.73-1.57,5.19-2,6.75-1s2.46,3.22,2.46,6.36v24a3.89,3.89,0,0,0,7.77,0v-24c0-6.08-2.26-10.73-6.35-13.09S321,70,315.68,73l-10.31,6c-9.51,5.49-17,18.4-17,29.39v24A3.89,3.89,0,0,0,292.28,136.27Z",
    transform: "translate(-280.9 -70.43)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.34b3fb0eae557ad375b7a111cc4c26be.svg";
export { ForwardRef as ReactComponent };